/** @jsx isolateComponent */

import { Button, Link } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import {
  useSendFullStoryEvent,
  useTrackEvent,
  useTrackingContext,
} from '@zapier/toolbox-tracking';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';

import { AutoUpgradeNudgeImage } from './AutoUpgradeNudgeImage';

type Props = {
  onAcceptClick: () => void;
  onDeclineClick: () => void;
};

export const AutoUpgradeNudgeView = ({
  onAcceptClick,
  onDeclineClick,
}: Props) => {
  const { trackEvent } = useTrackingContext();

  useSendFullStoryEvent('Viewed Auto Upgrade Modal - Nudge View');
  useTrackEvent('auto_upgrade_modal_nudge_view');

  return (
    <UpgradeNudgeLayout
      bodyText={
        <span>
          Never worry about running out of tasks again. Opt in to our beta, and
          we'll automatically upgrade your task tier if you hit your current
          task limit.{' '}
          <Link href="/l/automatic-task-upgrades" target="_blank">
            Learn more
          </Link>
        </span>
      }
      buttons={[
        <Button
          color="secondary"
          key="decline-button"
          onClick={() => {
            trackEvent('auto_upgrade_modal_nudge_view_decline_button');
            onDeclineClick();
          }}
        >
          No thanks
        </Button>,
        <Button
          hasShadow={true}
          key="accept-button"
          onClick={() => {
            trackEvent('auto_upgrade_modal_nudge_view_accept_button');
            onAcceptClick();
          }}
        >
          Opt in
        </Button>,
      ]}
      headingText="Automatic task upgrade"
      id="auto-upgrade"
      image={<AutoUpgradeNudgeImage />}
      subtitleText="New"
    />
  );
};
